<template>
  <div class="content">
    <el-row :gutter="24">
      <el-col :xs="24">

        <card
            :loading="loadingUser"
            :maxWidth="'auto'"
            :width="'100%'"
            class="user-card"
        >

          <div class="top-user-block">
            <div class="top-user-block__photo">
              <letters-avatar :name="user && user.name ? user.name : ''" size="60" type="big"/>
            </div>
            <div class="top-user-block__text text-block">
              <div class="text-block__name"> {{ user.name }} <span>{{ user.id }}</span></div>
              <div class="text-block__subtitle"> {{ user.age | age }} •
                {{ user.gender_type | genderTitle }}
                •
                id{{ user.id }}
              </div>
            </div>
          </div>

          <div class="user-data" v-if="user !== {}">
            <div class="user-data__item">
              <div class="user-data__title">Телефон</div>
              <div class="user-data__data">
                <i class="el-icon-phone-outline"></i> {{ user.phone }}
              </div>
            </div>

            <div class="user-data__item">
              <div class="user-data__title">ID клиента</div>
              <div class="user-data__data">{{ user.id }}</div>
            </div>
            <div class="user-data__item">
              <div class="user-data__title">Последний визит:</div>

              <div v-if="user.last_screening" class="user-data__data">
                {{ $root.dateDefault(user.last_screening) }}
                <span class="user-data__badge">с</span
                >{{
                  $root.timeIso(user.last_screening)
                }}<span class="user-data__badge">до</span
              >{{ $root.timeIso(user.last_screening) }}
              </div>
              <div v-else class="user-data__badge">-</div>

            </div>

            <div class="user-data__item">
              <div class="user-data__title">Последняя активность:</div>

              <div v-if="user.last_activity" class="user-data__data">
                {{ $root.dateDefault(user.last_activity) }}
                <span class="visit-data__badge">с</span
                >{{
                  $root.timeIso(user.last_activity)
                }}<span class="visit-data__badge">до</span
              >{{ $root.timeIso(user.last_activity) }}
              </div>
              <div v-else class="visit-data__data">-</div>


            </div>
          </div>


        </card>



        <collapse-card :loading="loadingUser" open class="collapse-card">
          <div slot="title">Информация о клиенте</div>
          <user-settings-panel v-if="showDataCard" :user="user"/>
        </collapse-card>

        <collapse-card :loading="loadingVisits" open class="collapse-card user-activities">
          <div slot="title">Активность</div>
          <div slot="link">
            <el-radio-group v-model="activeTabVisit" class="departments-radio-group">
              <el-radio-button :key="1" :label="1">Записи</el-radio-button>
              <el-radio-button :key="2" :label="2">История</el-radio-button>
            </el-radio-group>
          </div>

          <reservation v-if="activeTabVisit == 1 && Object.keys(user).length !== 0" :user="user"
                       @reloadDataUser="loadUserInfo"/>
          <activity-history v-if="activeTabVisit === 2" :user="user" @reloadDataUser="loadUserInfo"/>

        </collapse-card>

        <collapse-card :loading="loadingUser" class="collapse-card user-subscription">
          <div slot="title">Абонементы клиента</div>
          <user-subscription :user="user" v-if="showDataCard"/>
        </collapse-card>

        <collapse-card :loading="loadingUser" class="collapse-card ">
          <div slot="title">Бонусы клиента</div>
          <div slot="link">
            <div class="balance">
              <div class="balance__summ">{{ user.balance }} H₵</div>
              <div class="balance__date">Состояние счета на {{ currentDate() }}</div>
            </div>
          </div>
          <user-loyalty :user="user" v-if="showDataCard" @reloadDataUser="loadUserInfo"/>
        </collapse-card>

        <collapse-card :loading="loadingVisits" class="collapse-card ">
          <div slot="title">История визитов клиента</div>
        </collapse-card>

      </el-col>

    </el-row>
    <el-row :gutter="5" class="content-box__btns">
      <el-button type="primary" @click="back">Закрыть</el-button>
    </el-row>
  </div>
</template>

<script>
import {mapActions} from "vuex"

import LettersAvatar from '@/components/elements/LettersAvatar'
import UserSettingsPanel from "@/components/elements/UserSettingsPanel/Panel"
import UserLoyalty from '@/components/elements/UserSettingsPanel/Loyalty'
import UserSubscription from "@/components/elements/UserSubscription/UserSubscription"

import Reservation from "@/components/elements/UserSettingsPanel/Reservation"
import ActivityHistory from "@/components/elements/UserSettingsPanel/ActivityHistory"
import CollapseCard from "@/components/elements/BigCard.vue"
import Card from "@/components/elements/Card.vue"

export default {
  name: "users.item",
  components: {
    LettersAvatar,
    Card,
    UserSettingsPanel,
    UserLoyalty,
    UserSubscription,
    Reservation,
    ActivityHistory,
    CollapseCard
  },
  data: function () {
    return {
      user: {},
      card: null,
      devices: null,
      loadForm: false,
      errorLoadCard: false,
      showDataCard: false,
      loadingUser: true,
      loadingVisits: true,
      activeTabVisit: 1,
      visitsList: [],
      pagination: {},
    };
  },
  computed: {
    userId() {
      return this.$route.params.id;
    },
    showPagination() {
      if (this.pagination) {
        return this.pagination.total > this.pagination.per_page;
      } else return false;
    },
  },

  created() {
    if (this.userId) this.loadLogic();
    // else this.$router.push({name: "user.list"});
  },
  filters: {
    bool(text) {
      return text ? "Да" : "Нет";
    },
    genderTitle(type) {
      let title = ''
      if (type == 'male') title = 'мужской';
      if (type == 'female') title = 'женский';
      return title
    },
    age(n) {
      let arr = ["год", "года", "лет"];
      return (
          n +
          " " +
          arr[
              n % 100 > 4 && n % 100 < 20
                  ? 2
                  : [2, 0, 1, 1, 1, 2][n % 10 < 5 ? n % 10 : 5]
              ]
      );
    },
  },
  methods: {
    ...mapActions({}),
    loadLogic() {

      this.getVisits()


    },
    currentDate() {
      return this.$root.dateDefault(new Date())
    },
    loadUserInfo() {

      this.loadingUser = true;
      this.$api.user
          .get(this.userId)
          .then((response) => {
            this.user = response.data;

          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки 😕",
              message: response.response.data.message,
            });
          })
          .finally(() => {
            this.loadingUser = false;
            this.showDataCard = true;
          });
    },

    getVisits(page = 1) {
      this.loadingVisits = true

      let params = {
        params: {
          page
        },
      }

      this.$api.user
          .visits(this.userId, params)
          .then((response) => {
            this.visitsList = response.data.data;
            if (response.data.meta)
              this.pagination = response.data.meta.pagination;

            this.loadUserInfo();
          })
          .catch(() => {
            this.$notify.error({
              title: "Ошибка загрузки списка 😕",
            });
          })
          .finally(() => {
            this.loadingVisits = false
          })
    },
    back() {
      this.$router.go(-1)
    }

  },
};
</script>

<style scoped lang="scss">
.content {
  max-width: 870px;
}

.collapse-card {
  max-width: 100% !important;
}

.title {
  color: #111;
  margin-top: 32px;

  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
}

.visit-data {
  margin: 32px 0 10px 0;
  padding-bottom: 10px;
  display: flex;
  align-items: flex-start;
  width: 100%;

  &__id {
    margin-top: 2px;
    color: #111;

    font-weight: 600;
    font-size: 22px;
    line-height: 26px;
  }

  &__name {
    margin-top: 5px;
    color: #8e8e93;

    font-weight: 500;
    font-size: 15px;
    line-height: 100%;
  }

  &__gender {
    margin-top: 8px;

    font-weight: normal;
    font-size: 13px;
    line-height: 16px;

    color: #8e8e93;
  }

  &__item {
    margin-right: 45px;
  }

  &__data {
    font-size: 13px;
    line-height: 16px;

    color: #111;
    margin-top: 10px;
  }

  &__badge {
    background: #b7bac0;
    border-radius: 2px;
    padding: 0 2px;
    margin: 0 4px;

    color: #fff;
    font-size: 11px;
  }

  &__department {
    font-size: 12px;
    padding-left: 10px;
    color: #ccc;
  }

  &__title {
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    color: #111;
  }
}

.error-load {
  margin: 0 auto;
  text-align: center;
}

.questions {
  margin: 0 auto;
  padding-top: 20px;
}

.questions-item {
  border: 1px solid #dbdbdb;
  background-color: #fff;
  color: #303133;
  transition: 0.3s;
  padding: 20px;
  max-width: 90%;
  margin: 0 0 10px 0;
  border-radius: 4px;
  overflow: hidden;

  &__name {
    color: #000;
    font-weight: 400;
    font-size: 18px !important;
    line-height: 26px;
    display: inline;

    span {
      padding-left: 10px;

      color: #409eff;
      line-height: 26px;
      display: inline;
    }
  }

  &__empty {
    color: #ccc;
  }

  &:hover {
    box-shadow: 2px 2px 24px 2px rgba(0, 0, 0, 0.1);
  }
}

.answer-list {
  padding-left: 10px;

  &-item {
    &__title {
      color: #333;
    }
  }
}

.answer {
  &__title {
    color: #333;
    display: inline-block;
  }
}

.btn {
  margin-top: 40px;
}

.pagination {
  padding: 0;
  margin: 10px 0 0 -5px;
}

.user-subscription, .user-activities {
  /deep/ .collapse__content {
    margin: 4px 4px !important;
  }
}

.balance {
  display: flex;
  align-items: center;

  &__summ {
    font-weight: 600;
    font-size: 20px;
    line-height: 41px;
    color: #43D3B3;
  }

  &__date {
    margin-left: 10px;

    font-size: 13px;
    line-height: 16px;

    color: #8E8E93;
  }
}

.el-radio-button {
  margin: 0 5px 0 0;
}

.user-card {
  margin: 24px 0 0 0;
  padding: 32px 48px;
}

.user-data {

  border-top: 1px solid #EAEAEA;
  padding-top: 32px;

  display: flex;
  align-items: flex-start;
  width: 100%;


  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 32px 0 16px 0;


  &__name {
    margin-top: 5px;
    color: #8e8e93;

    font-weight: 500;
    font-size: 15px;
    line-height: 100%;
  }


  &__item {
    margin-right: 50px;
  }

  &__data {
    font-size: 13px;
    line-height: 16px;

    color: #111;
    margin-top: 10px;

    &_span {
      background: #b7bac0;
      border-radius: 2px;
      padding: 0px 5px;
      margin: 0 4px;

      color: #fff;
      font-size: 11px;
    }
  }


  &__title {
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    color: #111;
  }
}


.top-user-block {
  display: flex;
  align-items: center;

  &__photo {

  }

  &__text {
    margin-left: 17px;
  }

  .text-block {

    &__name {
      display: flex;
      align-items: baseline;

      font-weight: 600;
      font-size: 24px;

      color: #111;

      span {
        margin-left: 7px;

        font-weight: 600;
        font-size: 16px;
        line-height: 26px;
        color: #8E8E93;
      }

    }

    &__subtitle {
      margin-top: 11px;
      font-size: 15px;

      color: #8E8E93;
    }
  }
}

</style>
